/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PriceWindow } from '../models';
// @ts-ignore
import type { PriceWindowUtilization } from '../models';
/**
 * PricingApi - axios parameter creator
 * @export
 */
export const PricingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDelete: async (priceWindowId?: number, strategyId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (priceWindowId !== undefined) {
                localVarQueryParameter['priceWindowId'] = priceWindowId;
            }

            if (strategyId !== undefined) {
                localVarQueryParameter['strategyId'] = strategyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsGet: async (priceWindowId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing/Details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (priceWindowId !== undefined) {
                localVarQueryParameter['priceWindowId'] = priceWindowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PriceWindowUtilization} [priceWindowUtilization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsPost: async (priceWindowUtilization?: PriceWindowUtilization, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing/Details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(priceWindowUtilization, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsResetPost: async (priceWindowId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing/Details/Reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (priceWindowId !== undefined) {
                localVarQueryParameter['priceWindowId'] = priceWindowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingGet: async (strategyId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (strategyId !== undefined) {
                localVarQueryParameter['strategyId'] = strategyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingPost: async (priceWindow?: PriceWindow, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(priceWindow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingPut: async (priceWindow?: PriceWindow, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(priceWindow, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricingApi - functional programming interface
 * @export
 */
export const PricingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingDelete(priceWindowId?: number, strategyId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingDelete(priceWindowId, strategyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingDetailsGet(priceWindowId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindowUtilization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingDetailsGet(priceWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PriceWindowUtilization} [priceWindowUtilization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingDetailsPost(priceWindowUtilization?: PriceWindowUtilization, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindowUtilization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingDetailsPost(priceWindowUtilization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingDetailsResetPost(priceWindowId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindowUtilization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingDetailsResetPost(priceWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingDetailsResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingGet(strategyId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceWindow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingGet(strategyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingPost(priceWindow?: PriceWindow, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingPost(priceWindow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingPut(priceWindow?: PriceWindow, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceWindow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingPut(priceWindow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PricingApi.pricingPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PricingApi - factory interface
 * @export
 */
export const PricingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricingApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDelete(priceWindowId?: number, strategyId?: number, options?: any): AxiosPromise<PriceWindow> {
            return localVarFp.pricingDelete(priceWindowId, strategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsGet(priceWindowId?: number, options?: any): AxiosPromise<PriceWindowUtilization> {
            return localVarFp.pricingDetailsGet(priceWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PriceWindowUtilization} [priceWindowUtilization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsPost(priceWindowUtilization?: PriceWindowUtilization, options?: any): AxiosPromise<PriceWindowUtilization> {
            return localVarFp.pricingDetailsPost(priceWindowUtilization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [priceWindowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingDetailsResetPost(priceWindowId?: number, options?: any): AxiosPromise<PriceWindowUtilization> {
            return localVarFp.pricingDetailsResetPost(priceWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingGet(strategyId?: number, options?: any): AxiosPromise<Array<PriceWindow>> {
            return localVarFp.pricingGet(strategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingPost(priceWindow?: PriceWindow, options?: any): AxiosPromise<PriceWindow> {
            return localVarFp.pricingPost(priceWindow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PriceWindow} [priceWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingPut(priceWindow?: PriceWindow, options?: any): AxiosPromise<PriceWindow> {
            return localVarFp.pricingPut(priceWindow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PricingApi - object-oriented interface
 * @export
 * @class PricingApi
 * @extends {BaseAPI}
 */
export class PricingApi extends BaseAPI {
    /**
     * 
     * @param {number} [priceWindowId] 
     * @param {number} [strategyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingDelete(priceWindowId?: number, strategyId?: number, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingDelete(priceWindowId, strategyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [priceWindowId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingDetailsGet(priceWindowId?: number, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingDetailsGet(priceWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PriceWindowUtilization} [priceWindowUtilization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingDetailsPost(priceWindowUtilization?: PriceWindowUtilization, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingDetailsPost(priceWindowUtilization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [priceWindowId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingDetailsResetPost(priceWindowId?: number, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingDetailsResetPost(priceWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [strategyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingGet(strategyId?: number, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingGet(strategyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PriceWindow} [priceWindow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingPost(priceWindow?: PriceWindow, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingPost(priceWindow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PriceWindow} [priceWindow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingPut(priceWindow?: PriceWindow, options?: RawAxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingPut(priceWindow, options).then((request) => request(this.axios, this.basePath));
    }
}

